import { Box, Heading, Link } from '@hover/blueprint';
import React from 'react';
import { URLS } from '../../../constants';
import ArrowButton from '../../ui/ArrowButton';

const Footer: React.FC = () => (
  <Box
    flexDir="column"
    alignItems="center"
    mt={{ base: 700, tablet: '80px' }}
    mb={1000}
    px={200}
  >
    <Heading
      textAlign="center"
      size={{ base: 300, tablet: 500 }}
      marginBottom={{ base: 500, tablet: 700 }}
      isDisplay
    >
      Interested in learning more about our products?
    </Heading>
    <ArrowButton
      as={Link}
      href={URLS.pricing.scheduleMeeting}
      colorScheme="primary"
      w={{ base: '286px', tablet: 'auto' }}
    >
      Schedule a meeting
    </ArrowButton>
  </Box>
);

export default Footer;
